import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=258f68b2&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258f68b2')) {
      api.createRecord('258f68b2', component.options)
    } else {
      api.reload('258f68b2', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=258f68b2&", function () {
      api.rerender('258f68b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/Footer.vue"
export default component.exports